import { Navigate } from "react-router";
import { useConfiguration } from "@/queries/configuration.queries";

export const RoleSelector = () => {
  const config = useConfiguration();

  if (config.isLoading) {
    return <p>Loading...</p>;
  }

  if (config.data?.coordinator?.isParalloy) {
    if (config.data?.coordinator.isInspector) {
      return <Navigate to="paralloy/inspector" />;
    } else {
      return <Navigate to="paralloy/welder" />;
    }
  }

  if (config.data?.coordinator?.isHitachi) {
    if (config.data?.coordinator.isInspector) {
      return <Navigate to="hitachi/inspector" />;
    } else {
      return <Navigate to="hitachi/welder" />;
    }
  }

  if (config.data?.coordinator?.isCDSEnergy) {
    if (config.data?.coordinator.isInspector) {
      return <Navigate to="cds/inspector" />;
    } else {
      return <Navigate to="cds/welder" />;
    }
  }

  if (config.data?.coordinator?.isInspector) {
    return <Navigate to="inspector" />;
  } else {
    return <Navigate to="welder" />;
  }
};
